import type {
  GetAiAuditByIdQuery,
  GetAiAuditByIdQueryVariables,
  GetAiAuditFilterOptionsQuery,
  GetAiAuditFilterOptionsQueryVariables,
  GetAiAuditsQuery,
  GetAiAuditsQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_AI_AUDITS: TypedDocumentNode<
  GetAiAuditsQuery,
  GetAiAuditsQueryVariables
> = gql`
  query GetAiAudits($limit: Int, $endpoint: String, $prompt: String) {
    aiAudits(limit: $limit, endpoint: $endpoint, prompt: $prompt) {
      id
      createdAt
      endpoint
      metadata
      prompt
      iteration
      maxIterations
      model
      instanceId
    }
  }
`;

export const GET_AI_AUDIT_FILTER_OPTIONS: TypedDocumentNode<
  GetAiAuditFilterOptionsQuery,
  GetAiAuditFilterOptionsQueryVariables
> = gql`
  query GetAiAuditFilterOptions {
    aiAuditFilterOptions {
      endpoints
      prompts
    }
  }
`;

export const GET_AI_AUDIT_BY_ID: TypedDocumentNode<
  GetAiAuditByIdQuery,
  GetAiAuditByIdQueryVariables
> = gql`
  query GetAiAuditById($id: String!) {
    aiAudit(id: $id) {
      id
      createdAt
      endpoint
      metadata
      prompt
      iteration
      maxIterations
      model
      instanceId
      input
      output
    }
  }
`;
